/**
 * Rgb 2 hex
 * this function converts a rgb string in hex
 */
const rgb2hex = (rgb) => {
  try {
    const rgbNew = rgb.match(
      /^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i
    );
    return rgbNew && rgbNew.length === 4
      ? `#${`0${parseInt(rgbNew[1], 10).toString(16)}`.slice(-2)}${`0${parseInt(
          rgbNew[2],
          10
        ).toString(16)}`.slice(-2)}${`0${parseInt(rgbNew[3], 10).toString(
          16
        )}`.slice(-2)}`
      : '';
  } catch (error) {
    return rgb;
  }
};

/**
 * Convert timestamp miliseconds
 * if the value is < 99999999999 means that the
 * date are in the year 1973, since we can't go back further than 1973
 * 99999999999 (11 digits) means Sat Mar 03 1973 09:46:39 UTC, we can assume that
 * this value is in seconds and we can convert it in miliseconds
 * @param int timestamp => could be in seconds or miliseconds
 * @return int timestamp in miliseconds
 */
export const convertTimestampMilliseconds = (timestamp) =>
  timestamp < 99999999999 ? timestamp * 1000 : timestamp;

/**
 * Dates are on same day
 * this function checks that two timestamp are on the same day
 * @param timestamp start
 * @param timestamp end
 * @return bool
 */
export const datesAreOnSameDay = (start, end) => {
  const first = new Date(convertTimestampMilliseconds(start));
  const second = new Date(convertTimestampMilliseconds(end));
  return (
    first.getFullYear() === second.getFullYear() &&
    first.getMonth() === second.getMonth() &&
    first.getDate() === second.getDate()
  );
};

export default rgb2hex;
